import React from 'react';
import PropTypes from 'prop-types';
import { IconExploreMore } from '../../../assets/images';

function DefaultChannel(props = {}) {
    const { Title, Description, btnText, Image, btnClick, isAnnouncement = false, bulletPoints = [] } = props;

    const renderDescription = () => {
        if (isAnnouncement && bulletPoints.length > 0) {
            return (
                <ul className="announcement-bullet-points">
                    {bulletPoints.map((point, index) => (
                        <li key={`bullet-${point}-${index}`}>{point}</li>
                    ))}
                </ul>
            );
        }
        return Description && <p>{Description}</p>;
    };

    return (
        <div className="channels-list-body">
            <div className={`channels-list-empty ${isAnnouncement ? 'announcement-banner' : ''}`}>
                {Image && (
                    <div className="channels-list-empty-icon">
                        <img src={Image} alt="Channels Icon" />
                    </div>
                )}
                <div className="channels-list-empty-text">
                    {Title && <h3>{Title} </h3>}
                    {renderDescription()}
                    {btnText && (
                        <button className="create-channel-btn primary" onClick={btnClick}>
                            <span>
                                {btnText === 'Explore More' && (
                                    <i className="icon">
                                        <IconExploreMore />
                                    </i>
                                )}
                                {btnText}
                            </span>
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
}
DefaultChannel.propTypes = {
    Title: PropTypes.string.isRequired,
    Description: PropTypes.string.isRequired,
    btnClick: PropTypes.func,
    btnText: PropTypes.string.isRequired,
    Image: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
    isAnnouncement: PropTypes.bool,
    bulletPoints: PropTypes.arrayOf(PropTypes.string),
};

export default DefaultChannel;
